import { render } from "./AddTagModal.vue?vue&type=template&id=a0142444&ts=true"
import script from "./AddTagModal.vue?vue&type=script&lang=ts"
export * from "./AddTagModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__